import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { Card, CardContent, Grid, Button } from "@material-ui/core/";
import { withStyles } from "@material-ui/core/styles";
import LoginStyles from "./LoginStyles";
import passwordsSchema from "./Password-schema";
import Classnames from 'classnames';
import Form from "./form";
import { resetPassword, resetLoginErrors } from "../Auth.ducks";
import Cookies from 'universal-cookie';
import queryString from 'querystring'
import srcIconLogo from "../../../styles/img/logo-kiuono-white.svg";
import { closeSnackBar } from "../../../reducers";
import { ErrorSnackbar, SuccessSnackbar } from "../../../components/IntegratedSnackbars";
import { API } from "../../../const";

import { useParams, Redirect } from "react-router-dom";
const LogoLogin = () => <object data={srcIconLogo} type="image/svg+xml" className="img-fluid logo-login" />

function ReinitPassword(props) {

  const handleReset = (values) => {
    const parsed = queryString.parse(props.location.search);
    let data = {
      "confirmPassword": values.confirmPassword,
      "password": values.password,
      "code": parsed["?code"]
    }
    props.resetPassword(data);
  };
  function handleCloseError() {
    props.closeSnackBar("errorMsg")
  }
  function handleCloseSuccess() {
    props.closeSnackBar("successMsg")
    window.location.href = `${API}creche/login`;
  }


  const {
    resetLoginErrors,
    classes: { root, formBtn },
    auth: { error },
    match
  } = props;
  const parsed = queryString.parse(props.location.search);
  const displayHide = { display: "none" }
  const displayShow = { display: "block" }
  return (

    <div className="main-wrapper login-page">
      {props.successMsg.status ? <SuccessSnackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={props.successMsg.status}
        autoHideDuration={2000}
        onClose={handleCloseSuccess}
        variant="success"
        display={displayHide}
        message={props.successMsg.message}
      /> : ""}
      {props.errorMsg.status ? <ErrorSnackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={props.errorMsg.status}
        onClose={handleCloseError}
        autoHideDuration={5000}
        variant="error"
        display={displayShow}
        message={props.errorMsg.message}
      /> : ""}
      <div className="container-login">
        <div className="entete-login">
          <LogoLogin />
          <h1>Votre halte-garderie, au quotidien.</h1>
        </div>
        <Formik
          initialValues={{ password: "", confirmPassword: "" }}
          validationSchema={passwordsSchema}
          onSubmit={(values, actions) => handleReset(values)}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            setFieldValue,
            errors,
            touched
          }) => {
            return (
              <form onSubmit={handleSubmit} className="box-login">
                <h2 className="mb-4">Nouveau mot de passe</h2>
                <div className={Classnames("form-group", { "error-mess": errors.password && touched.password })}>
                  <input type="password" onChange={handleChange} name="password" className="form-control" id="ipt-password" placeholder="Nouveau mot de passe" />
                  {errors.password && touched.password ? (
                    <p >{errors.password}</p>
                  ) : null}
                  {/* {error ? (
                    <p >{error}</p>
                  ) : null} */}
                </div>
                <div className={Classnames("form-group mb-2", { "error-mess": errors.confirmPassword && touched.confirmPassword })}>
                  <input type="password" onChange={handleChange} name="confirmPassword" className="form-control" id="ipt-password-confirm" placeholder="Confirmer le mot de passe" />
                  {errors.confirmPassword && touched.confirmPassword ? (
                    <p >{errors.confirmPassword}</p>
                  ) : null}
                  {/* {error ? (
                    <p >{error}</p>
                  ) : null} */}
                </div>
                <button type="submit"
                  onClick={handleSubmit} className="btn-gradient mt-4">Valider</button>

              </form>
            );
          }}
        </Formik>
      </div>
      {/* {props.successMsg.status ? <Redirect to="/login" /> : ""} */}
    </div>
  );
}

const mapStateToProps = ({ auth, successMsg, errorMsg }) => ({ auth, successMsg, errorMsg });

const mapDispatchToProps = { resetPassword, resetLoginErrors, closeSnackBar };

const withStore = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withStyles(LoginStyles)(withStore(ReinitPassword));
